module.exports = __webpack_public_path__ + "assets/img/logo-ie-text-c6ab.svg";